import { Component } from '@angular/core';

@Component({
  selector: 'app-kill-switch',
  templateUrl: './kill-switch.component.html',
  standalone: true,
})
export class KillSwitchComponent {}
